/* eslint-disable import/prefer-default-export */
/* eslint-disable */

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
  AUTO: 'auto',
}
